import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'my_hp_no_fin',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isMyHp() || this.isMDT()) && !this.isFin();
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/MyHpNoFinPerimeter.js